import { useCallback, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../App";
import { handleUpdateUser } from "./UpdateUserState";

const useProfileSync = (fetchProfile, onProfile) => {
  const { userData, setUserData } = useContext(UserContext);
  const location = useLocation();
  const userDataRef = useRef(userData);
  const onProfileRef = useRef(onProfile);

  userDataRef.current = userData;
  onProfileRef.current = onProfile;

  const syncProfile = useCallback(async () => {
    if (!userDataRef.current?.id) return;

    try {
      const res = await fetchProfile({ skipLoader: true });

      if (Math.floor(res?.status / 100) !== 2) return;

      const data = res?.data?.data || {};
      onProfileRef.current?.(data);

      const current = userDataRef.current;
      const pageAccessChanged =
        data.page_access &&
        JSON.stringify(data.page_access) !==
          JSON.stringify(current?.page_access || {});
      const roleChanged = data.role && data.role !== current?.role;

      if (pageAccessChanged || roleChanged) {
        handleUpdateUser(setUserData, {
          ...current,
          ...(data.role ? { role: data.role } : {}),
          ...(data.page_access ? { page_access: data.page_access } : {}),
        });
      }
    } catch (err) {
      console.error("Failed to sync profile:", err);
    }
  }, [fetchProfile, setUserData]);

  useEffect(() => {
    syncProfile();
  }, [userData?.id, location.pathname, syncProfile]);

  useEffect(() => {
    window.addEventListener("focus", syncProfile);
    return () => window.removeEventListener("focus", syncProfile);
  }, [syncProfile]);
};

export default useProfileSync;
